import axios from 'axios';

let prefix = "/our-customer"

const OurCustomerApi = {

	getOurCustomerList(payload){
		return axios.get( prefix + "/list", {params: payload})
	},
	getOurCustomerById(id, payload){
		return axios.get( prefix + "/get/" + id, {params: payload})
	},
	createOurCustomer(payload){
		return axios.post( prefix + "/create", payload)
	},
	updateOurCustomer(payload){
		return axios.post( prefix + "/update", payload)
	},
	archiveOurCustomer(payload){
		return axios.delete( prefix + "/delete", {params: payload})
	},

}

export default OurCustomerApi;
